import React, { useEffect, useState } from 'react'
import { Card } from 'reactstrap'
import Swal from 'sweetalert2/dist/sweetalert2.js'
import 'sweetalert2/dist/sweetalert2.min.css'
import 'sweetalert2/src/sweetalert2.scss'
import errorSound from '../../assets/audio/alert-error.wav'
import Breadcrumb from '../../components/common/breadcrumb'
import SorgulamaEkrani from '../../components/common/sorgulama-component/sorgulama-ekrani'
import useFormatMessage from '../../utils/useFormatMessage'

const RihtimCikis = () => {
    const { t } = useFormatMessage()
    const [data, setData] = useState(null)

    useEffect(() => {
        if (!data) return

        if (data.error) {
            // Hata durumunda
            if (navigator.vibrate) {
                navigator.vibrate(500)
            }
            const errorAudio = document.getElementById("errorSound")
            errorAudio.play()
            // ${t(data.error)}
            let err = data.error.includes("antrepo: false") ? "Aracın çıkış izni yoktur." : data.error
            Swal.fire({
                icon: 'error',
                title: 'Hata',
                html: `<div style="font-size: 24px;">
                ${t(err)}
                </div>`,
                showConfirmButton: true,
                confirmButtonText: 'Tamam',
                allowOutsideClick: false,
                allowEscapeKey: false,
                background: '#fff5f5',
                customClass: {
                    popup: 'swal2-popup-large'
                }
            })
            return
        }

        if (data.address) {
            Swal.fire({
                icon: 'success',
                title: 'Yönlendirme',
                html: `<div style="font-size: 24px;">${data.address.address_code}</div>`,
                timer: 3000,
                showConfirmButton: false,
                position: 'center',
                allowOutsideClick: false,
                customClass: {
                    popup: 'swal2-popup-large'
                }
            }).then(() => {
                // 5 saniye sonra input'u temizle ve fokusla
                const input = document.querySelector('input[type="text"]')
                if (input) {
                    input.value = ''
                    input.focus()
                }
            })
        }
        // eslint-disable-next-line
    }, [data])

    return (
        <>
            <Breadcrumb current={t("Gümrüklü Saha Çıkış")} depo={false} />
            <Card className='p-2'>
                <SorgulamaEkrani
                    apiEndpoint="/checkAndAssign"
                    body={"chassis_no"}
                    setData={setData}
                    minCharacter={17}
                    depo={false}
                    role_name={"gumruklu_saha_write"}
                />
                <audio id="errorSound" src={errorSound} preload="auto"></audio>

                <style>
                    {`
                        .swal2-popup-large {
                            width: 600px !important;
                        }
                        .swal2-title {
                            font-size: 28px !important;
                        }
                        .swal2-html-container {
                            font-size: 24px !important;
                            margin: 1em 0 !important;
                        }
                    `}
                </style>
            </Card>
        </>
    )
}

export default RihtimCikis